import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";
import { DepartmentService, DepartmentFormService } from "../shared";

@Component({
  selector: "department-form",
  templateUrl: "./department-form.component.html",
  styleUrls: ["./department-form.component.scss"],
})
export class DepartmentFormComponent implements OnInit {
  @Input() id: string;
  @Output() onSave: EventEmitter<string> = new EventEmitter();
  @Output() onDuplicate: EventEmitter<string> = new EventEmitter();
  @Output() onRemove: EventEmitter<string> = new EventEmitter();
  @Output() onBack: EventEmitter<any> = new EventEmitter();

  loading: boolean = false;
  form: FormGroup;

  constructor(
    public ft: FormToolsService,
    public dataService: DepartmentService,
    public formService: DepartmentFormService
  ) {}

  ngOnInit() {}

  ngOnChanges() {
    this.form = null;

    if (this.id) {
      this.loading = true;

      this.dataService.getById(this.id).subscribe((item) => {
        this.form = this.formService.getForm(item);
        this.loading = false;
      });
    } else {
      setTimeout(() => {
        this.form = this.formService.getForm();
      }, 100);
    }
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/departments/department-form/department-form.component.ts